define([
	"dojo/_base/declare",
	"csi/action/DeleteController"
], function(declare,DeleteController) {

	return declare(DeleteController, {
		// Number: number of nodes deleted
		nDelete: 1,

		// Boolean: indicates that action works on view refNode
		bRefNode: true,

		constructor: function(/*Object*/params) {
			// summary: make sure refNode is from view rather than heading
			if (this.refNode && !this.widget.isRefNode(this.refNode)) {
				this.refNode = this.widget.getRefNode(this.refNode);
			}
		},

		postProcessSuccess: function() {	
			// summary: remove associated DOM nodes
			this.inherited(arguments);
			this.widget.deleteBlock(this.refNode);
		}
	});
});